export default "__VITE_ASSET__uXTJi3gE__"